import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '@/core/services/auth-service';
import { LayoutService } from '../service/layout.service';

interface NavItem {
    label: string;
    icon: string;
    link: string;
}

@Component({
    standalone: true,
    selector: 'app-footer',
    imports: [RouterLink, RouterLinkActive],
    template: `
        <!-- فوتر دسکتاپ -->
        <div class="layout-footer hidden lg:flex">
            طراحی شده توسط
            <a href="https://navaweb.net" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">شرکت نوا وب</a>
        </div>

        <!-- نویگیشن پایین موبایل و تبلت: میان‌برهای پرکاربرد طبق دسترسی کاربر -->
        <nav class="mobile-nav lg:hidden" dir="rtl">
            @for (item of side.slice(0, 2); track item.link) {
                <a class="mobile-nav__item" [routerLink]="item.link" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="is-active">
                    <i [class]="item.icon"></i>
                    <span>{{ item.label }}</span>
                </a>
            }

            @if (canCreate) {
                <a class="mobile-nav__fab" routerLink="/reservations/new" aria-label="ثبت رزرو جدید">
                    <i class="pi pi-plus"></i>
                </a>
            }

            @for (item of side.slice(2, 3); track item.link) {
                <a class="mobile-nav__item" [routerLink]="item.link" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="is-active">
                    <i [class]="item.icon"></i>
                    <span>{{ item.label }}</span>
                </a>
            }

            <button type="button" class="mobile-nav__item" (click)="layout.onMenuToggle()">
                <i class="pi pi-bars"></i>
                <span>منو</span>
            </button>
        </nav>
    `,
    styles: [`
        .mobile-nav {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 997;
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 64px;
            padding: 0 0.25rem;
            padding-bottom: env(safe-area-inset-bottom, 0);
            background: var(--surface-card, #fff);
            border-top: 1px solid var(--surface-border, #e5e7eb);
            box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.06);
        }

        .mobile-nav__item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            background: none;
            border: none;
            cursor: pointer;
            padding: 0.35rem 0;
            font-size: 0.7rem;
            font-weight: 600;
            font-family: inherit;
            color: var(--text-color-secondary, #6b7280);
            text-decoration: none;
            transition: color 0.15s ease;
        }
        .mobile-nav__item i { font-size: 1.15rem; }
        .mobile-nav__item:hover,
        .mobile-nav__item.is-active { color: var(--primary-color); }

        .mobile-nav__fab {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 54px;
            height: 54px;
            margin-top: -22px;
            border-radius: 9999px;
            background: var(--primary-color);
            color: var(--primary-contrast-color, #fff);
            box-shadow: 0 6px 16px color-mix(in srgb, var(--primary-color) 45%, transparent);
            border: 4px solid var(--surface-card, #fff);
            font-size: 1.3rem;
        }
    `]
})
export class AppFooter {
    readonly layout = inject(LayoutService);
    private readonly auth = inject(AuthService);

    canCreate = this.auth.can('reservations.create');

    side: NavItem[] = [
        { label: 'داشبورد', icon: 'pi pi-home', link: '/', permission: 'dashboard.view' },
        { label: 'وضعیت اتاق‌ها', icon: 'pi pi-calendar', link: '/room-availability', permission: 'reservations.view' },
        { label: 'رزروها', icon: 'pi pi-list', link: '/reservations', permission: 'reservations.view' },
        { label: 'مشتریان', icon: 'pi pi-id-card', link: '/customers', permission: 'customers.view' },
        { label: 'راهنما', icon: 'pi pi-question-circle', link: '/help', permission: '' },
    ]
        .filter((i) => (i.permission ? this.auth.can(i.permission) : true))
        .map(({ permission, ...i }) => i);
}
